/**
 * @generated SignedSource<<9d0112a424e829068aee0ce4b184f82e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type JSMSubscriptionStatus = "ACTIVE" | "FAILED" | "NONE" | "TRIGGERED";
export type omnichannelMetaQuery$variables = Record<PropertyKey, never>;
export type omnichannelMetaQuery$data = {
  readonly jsmChatConversationMeta: {
    readonly aiAnswerStatus: string | null;
    readonly connectionId: string | null;
    readonly conversationContextAri: string | null;
    readonly conversationId: string | null;
    readonly disableInput: boolean | null;
    readonly draftMessage: string | null;
    readonly isConversationClosed: boolean | null;
    readonly isConversationExpired: boolean | null;
    readonly isReplyPending: boolean | null;
    readonly subscriptionId: string | null;
    readonly subscriptionStatus: JSMSubscriptionStatus | null;
    readonly subscriptionTriggered: boolean | null;
    readonly workspaceAri: string | null;
  } | null;
};
export type omnichannelMetaQuery = {
  response: omnichannelMetaQuery$data;
  variables: omnichannelMetaQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "ClientExtension",
    "selections": [
      {
        "concreteType": "JsmChatConversationMeta",
        "kind": "LinkedField",
        "name": "jsmChatConversationMeta",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "conversationId"
          },
          {
            "kind": "ScalarField",
            "name": "conversationContextAri"
          },
          {
            "kind": "ScalarField",
            "name": "workspaceAri"
          },
          {
            "kind": "ScalarField",
            "name": "connectionId"
          },
          {
            "kind": "ScalarField",
            "name": "isReplyPending"
          },
          {
            "kind": "ScalarField",
            "name": "isConversationExpired"
          },
          {
            "kind": "ScalarField",
            "name": "aiAnswerStatus"
          },
          {
            "kind": "ScalarField",
            "name": "isConversationClosed"
          },
          {
            "kind": "ScalarField",
            "name": "draftMessage"
          },
          {
            "kind": "ScalarField",
            "name": "disableInput"
          },
          {
            "kind": "ScalarField",
            "name": "subscriptionId"
          },
          {
            "kind": "ScalarField",
            "name": "subscriptionTriggered"
          },
          {
            "kind": "ScalarField",
            "name": "subscriptionStatus"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "omnichannelMetaQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "omnichannelMetaQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "9615b9f4fbe1d3c4564d22bfc3ed4951",
    "id": null,
    "metadata": {},
    "name": "omnichannelMetaQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "96778225e661ec1b102bb65714d88315";

export default node;
